import _ from 'lodash'
import { AutoComplete } from 'primereact/autocomplete'
import { useState } from 'react'

import { Input, Spinner } from '../../Components'
import { useAuth } from '../../Provider/AuthProvider'
import { FC } from '../../Services'
import { cap } from '../../State'
import { translations } from '../../translations'
import { alert } from '../AdminCoefficient/Functions'
import options from '../Gigi/Resources/airports.json'
import { CardResult } from './CardResult'
import { seatOptions } from './Functions'

const language = cap.language.state || 'IT'
const t = translations[language]

const checkDateFormat = (date) => /^\d{1,2}-\d{1,2}-\d{4}$/.test(date)
const checkHourFormat = (hour) => /^\d{1,2}:\d{1,2}$/.test(hour)

const searchIataCode = (setter) =>
  _.debounce((event) => {
    if (!event.query.trim().length) setter([...options])
    else {
      setter([
        ...options.filter(({ value }) => value.toLowerCase().startsWith(event.query.toLowerCase())),
        ...options.filter(({ label }) => label.toLowerCase().includes(event.query.toLowerCase()))
      ])
    }
  }, 1000)

export const PlaneServices = (type) => {
  const [departureDate, setDepartureDate] = useState('15-01-2024')
  const [departureHour, setDepartureHour] = useState('10:00')
  const {
    user: {
      user: {
        environment: { codSociety }
      }
    }
  } = useAuth()
  const [idCommunity, setIdCommunity] = useState(
    codSociety === '90'
      ? '26'
      : import.meta.env.MODE === 'development' || import.meta.env.MODE === 'staging'
        ? '87'
        : '1'
  )
  const [departureAirport, setDepartureAirport] = useState()
  const [arrivalAirport, setArrivalAirport] = useState()
  const [results, setResults] = useState([])
  const [seatPreference, setSeatPreference] = useState('')
  const [bagKg, setbagKg] = useState('')
  const [isSearching, setIsSearching] = useState(false)
  const [suggestionsArrivalAirport, setSuggestionsArrivalAirport] = useState([])
  const [suggestionsDepartureAirport, setSuggestionsDepartureAirport] = useState([])

  const sendRequest = async () => {
    setResults([])
    if (!departureAirport) return alert('error', t.tdAeroportoPartenzaNonValido)
    if (!arrivalAirport) return alert('error', t.tdAeroportoArrivoNonValido)
    if (!checkDateFormat(departureDate) || !checkHourFormat(departureHour))
      return alert('error', t.tdFormatoDataOraNonValido)
    setIsSearching(true)
    try {
      const res = await FC.service('info').create({
        action: 'previewDynResults',
        serviceType: 'Plane',
        bagKg,
        departureDate,
        seatPreference,
        departureHour,
        departureAirport,
        arrivalAirport,
        idCommunity
      })
      setResults(res)
    } catch (error) {
      alert('error', t.errore, error?.message || 'Errore durante la ricerca')
    } finally {
      setIsSearching(false)
    }
  }

  return (
    <div className="nsec">
      <div className="nsec__head">
        <div className="nsec__ico">
          <i className="pi pi-send" style={{ fontSize: 16 }} />
        </div>
        <h3 className="nsec__title">{t.tdAereo}</h3>
        {results.length > 0 && (
          <span className="nbadge nbadge--info" style={{ marginLeft: 8 }}>
            {results.length} {t.tdRisultati}
          </span>
        )}
      </div>
      <div className="nsec__body">
        <div className="testdyn-filters-row">
          <div className="nfield">
            <label htmlFor="idCommunity">{t.tdIdCommunity}</label>
            <Input
              value={idCommunity}
              onChange={({ idCommunity }) => setIdCommunity(idCommunity)}
              id="idCommunity"
              onEnter={sendRequest}
              style={{ width: '100%' }}
            />
          </div>
          <div className="nfield">
            <label htmlFor="bagKg">{t.tdKgBagaglio}</label>
            <Input
              id="bagKg"
              dropdown
              options={['', '5', '10', '15', '20', '25']}
              value={bagKg}
              onChange={({ bagKg }) => setbagKg(bagKg)}
              style={{ width: '100%' }}
              onEnter={sendRequest}
            />
          </div>
          <div className="nfield">
            <label htmlFor="seatPreference">{t.tdPreferenzaPosto}</label>
            <Input
              id="seatPreference"
              dropdown
              options={seatOptions}
              value={seatPreference}
              onChange={({ seatPreference }) => setSeatPreference(seatPreference)}
              style={{ width: '100%' }}
              onEnter={sendRequest}
            />
          </div>
          <div className="nfield">
            <label htmlFor="departureAirport">{t.tdAeroportoPartenza}</label>
            <AutoComplete
              field="value"
              id="departureAirport"
              onSelect={({ value: { value } }) => setDepartureAirport(value)}
              style={{ width: '100%' }}
              value={departureAirport}
              suggestions={suggestionsDepartureAirport}
              completeMethod={searchIataCode(setSuggestionsDepartureAirport)}
              onChange={(e) => setDepartureAirport(e.value)}
              inputStyle={{ width: '100%', borderRadius: 8 }}
              forceSelection
              itemTemplate={({ both = '' }) => both}
            />
          </div>
          <div className="nfield">
            <label htmlFor="arrivalAirport">{t.tdAeroportoArrivo}</label>
            <AutoComplete
              field="value"
              id="arrivalAirport"
              onSelect={({ value: { value } }) => setArrivalAirport(value)}
              style={{ width: '100%' }}
              value={arrivalAirport}
              suggestions={suggestionsArrivalAirport}
              completeMethod={searchIataCode(setSuggestionsArrivalAirport)}
              onChange={(e) => setArrivalAirport(e.value)}
              inputStyle={{ width: '100%', borderRadius: 8 }}
              forceSelection
              itemTemplate={({ both = '' }) => both}
            />
          </div>
          <div className="nfield">
            <label htmlFor="departureDate">{t.tdDataPartenza}</label>
            <Input
              value={departureDate}
              onChange={({ departureDate }) => setDepartureDate(departureDate)}
              id="departureDate"
              onEnter={sendRequest}
              style={{ width: '100%' }}
            />
          </div>
          <div className="nfield">
            <label htmlFor="departureHour">{t.tdOraPartenza}</label>
            <Input
              value={departureHour}
              onChange={({ departureHour }) => setDepartureHour(departureHour)}
              id="departureHour"
              onEnter={sendRequest}
              style={{ width: '100%' }}
            />
          </div>
        </div>
        <div style={{ marginTop: 16 }}>
          {isSearching ? (
            <Spinner />
          ) : (
            <button type="button" className="nbtn nbtn--primary" onClick={sendRequest}>
              <i className="pi pi-search" style={{ fontSize: 14 }} />
              {t.tdCerca}
            </button>
          )}
        </div>
      </div>
      {results.length > 0 && (
        <div className="nsec__body nsec__body--flush">
          <table className="ntable">
            <thead>
              <tr>
                <th style={{ width: 90 }}>{t.tdTratta}</th>
                <th>{t.tdCompagnia}</th>
                <th style={{ width: 90 }}>{t.tdPartenza}</th>
                <th style={{ width: 90 }}>{t.tdArrivo}</th>
                <th style={{ width: 100, textAlign: 'right' }}>{t.tdPrezzo}</th>
              </tr>
            </thead>
            <tbody>
              {results.map((result, index) => {
                const route = result?.routes?.[0] || {}
                return (
                  <tr key={index}>
                    <td>
                      <span
                        style={{ fontFamily: 'var(--font-mono)', fontSize: 12.5, fontWeight: 600 }}
                      >
                        {route.labelDeparture} → {route.labelArrival}
                      </span>
                    </td>
                    <td>{route.companyLabel || route.company}</td>
                    <td>
                      <span className="ntable__num">{route.hourDeparture}</span>
                    </td>
                    <td>
                      <span className="ntable__num">{route.hourArrival}</span>
                    </td>
                    <td style={{ textAlign: 'right' }}>
                      <span className="ntable__num" style={{ fontWeight: 600 }}>
                        €{result.price}
                      </span>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      )}
      <div className="testdyn-results-grid">
        {results.map((result, index) => (
          <CardResult key={index} result={result} type={result?.serviceType} />
        ))}
      </div>
    </div>
  )
}
